<template>
  <div>
    <div class="header space-between">
      <div class="logo-wrap">
        <img src="../../assets/new_logo.png" class="logo">
        <span class="name">加西亚</span>
      </div>

      <div class="header-out">
        <span @click="clickToPMIAction" class="app-name" style="text-decoration: underline;margin-right: 15px;">新干线观察电脑端
          >
        </span>
        <!-- <span @click="showPop" class="app-name">新干线观察电脑端 ></span> -->
        <img class="header-img" :src="$loadImg($store.state.user.logourl)">
        <div class="info">
          <span>{{ $store.state.user.dispname }}</span>
          <span class="userid">ID {{ $store.state.user.userid }}</span>
        </div>
        <span class="login-out" @click="confirmShow">[退出]</span>
      </div>
    </div>
  </div>
</template>
<script>
import { loginOut } from 'api/user'
export default {
  components: {
  },
  props: {
    islogin: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    confirmShow() {
      let _this = this
      const confirm = this.$confirm({
        conDesc: '你是否确定退出登录？',
        cancelA() {
          confirm.close()
        },
        confirmA() {
          loginOut()
          confirm.close()
          _this.$router.replace({ name: 'login' })
        }
      })
    },
    showPop() {
      this.$emit('showPop', false)
    },
    clickToPMIAction() {
      window.open('https://pmi.xb969.com/shop/login', '_blank')
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~common/stylus/variable"
.header
  height: 50px
  background-color: #2f4a68
  color: $text-color-white
  padding: 0 30px
.logo-wrap
  display: flex
  align-items: center
.logo
  width: 160px
  height: 18px
  margin-right: 15px
.name
  font-size: $font-size-large-s
.app-name
  font-size: $font-size-medium-x
  cursor: pointer
.header-out
  display: flex
  align-items: center
  font-size: $font-size-small
.info
  margin: 0 20px 0 12px
  display: flex
  flex-direction: column
  text-align: left
  .userid
    margin-top: 6px
    font-size: $font-size-small-s
.login-out
  font-size: $font-size-small
  cursor: pointer
</style>



// WEBPACK FOOTER //
// src/base/header/header.vue